const scopeGapi = [
  'https://mail.google.com',
  'https://www.googleapis.com/auth/pubsub',
  'https://www.googleapis.com/auth/cloud-platform',
  'https://www.googleapis.com/auth/contacts',
  'https://www.googleapis.com/auth/admin.directory.user'
].join(' ')

const discoveryDocs = [
  'https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest',
  'https://content.googleapis.com/discovery/v1/apis/admin/directory_v1/rest'
]

export {scopeGapi, discoveryDocs}



// WEBPACK FOOTER //
// ./src/constants/googleApi/scopeGapi.js